export const WORKER_NAME_REQUIRED_ERROR = 'Worker name is required'
export const WORKER_NAME_NUMERIC_ONLY_ERROR = 'Worker name cannot be numeric-only'

export function validateWorkerName(value: string): string | null {
    const trimmed = value.trim()
    if (!trimmed) {
        return WORKER_NAME_REQUIRED_ERROR
    }
    if (/^\d+$/.test(trimmed)) {
        return WORKER_NAME_NUMERIC_ONLY_ERROR
    }
    return null
}
